import(/* webpackMode: "eager" */ "/var/www/dental/frontend/src/app/not-found.tsx");
